import { useEffect } from "react";
import { LibString } from "../../util/libString";
import "./style.css";

export const ListFilter = (props) => {
	const { capitalizeFirstLetter } = LibString();
	const filterData = props.filterData;

	return (
		<>
			{filterData && typeof filterData === "object" && Object.entries(filterData).length > 0 && (
				<div className="container-filter d-flex flex-column ms-2">
					<strong className="text-[10px]">Filtros aplicados</strong>
					{filterData.param && filterData.param !== undefined && (
						<div className="flex text-[10px] gap-1">
							<strong>Parâmetro:</strong>
							<span className="text-[10px]">{`${capitalizeFirstLetter(
								filterData.param
							)}  ${capitalizeFirstLetter(filterData.paramValue)} `}</span>
						</div>
					)}
					{filterData.ativo && filterData.param !== undefined && (
						<div className="flex  text-[10px] gap-1">
							<strong>Ativo:</strong>
							<span>{`${capitalizeFirstLetter(filterData.ativo)}`}</span>
						</div>
					)}
					{/* {filterData.recordCount &&
					filterData.recordCount !== undefined && (
						<span>{`Registro Encontrados: ${filterData.recordCount}`}</span>
					)} */}
				</div>
			)}
		</>
	);
};
